import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var RefreshIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M41.2399 8.72001L36.8099 13.1501L36.3499 12.69C33.7848 10.1151 30.4472 8.45094 26.8471 7.9517C23.247 7.45246 19.5824 8.14562 16.4134 9.92533C13.2444 11.705 10.7452 14.4734 9.2978 17.8073C7.85039 21.1412 7.53435 24.8574 8.39796 28.3879C9.26157 31.9183 11.2573 35.0689 14.0803 37.3582C16.9032 39.6475 20.3981 40.9496 24.0308 41.0655C27.6635 41.1814 31.2343 40.1048 34.1974 38C37.1605 35.8953 39.3531 32.8783 40.44 29.4101H37.26C36.3545 31.7112 34.8387 33.7218 32.8757 35.2257C30.9127 36.7297 28.5768 37.67 26.1193 37.9455C23.6618 38.2209 21.1757 37.8211 18.9285 36.789C16.6813 35.7569 14.758 34.1316 13.3656 32.0881C11.9731 30.0445 11.1642 27.6598 11.0258 25.1908C10.8875 22.7218 11.425 20.2618 12.5804 18.0755C13.7358 15.8891 15.4655 14.0593 17.5834 12.7826C19.7012 11.506 22.127 10.8308 24.5999 10.83C26.3823 10.8277 28.1473 11.1802 29.7921 11.867C31.4368 12.5537 32.9284 13.5609 34.1799 14.83L34.63 15.2901L28.33 21.59H41.2399V8.72001Z"
  }));
});
RefreshIcon.displayName = 'RefreshIcon';
RefreshIcon.defaultProps = {
  'aria-label': 'Refresh'
};
export default RefreshIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/RefreshIcon/index.js
// module id = 1925
// module chunks = 12